import angular from 'angular';
import { sortBy, toArray, filter, extend, cloneDeep, map, intersection, concat, values } from 'lodash';
import moment from 'moment-timezone';
import '../../services/area';
import '../../services/line';
import '../../services/notifications';
import '../../services/place';
import '../../services/errors';
import '../../services/date-handler';
import '../modals/holiday';
import '../modals/holiday-info';

const module = angular.module('whyline.controllers.schedule-holidays', [

  'whyline.services.area',
  'whyline.services.holiday',
  'whyline.modals.holiday-info',
  'whyline.modals.holiday',
  'whyline.services.notifications',
  'whyline.services.errors',
  'whyline.services.place',
  'whyline.services.date-handler',
]);

const ScheduleHolidaysController = ($scope, $uibModal, $translate, $timeout, AreaService, LineService, HolidayService, ErrorService, PlaceService, NotificationService, dialog) => {
  /*@ngInject*/

  $scope.place = PlaceService.GetCurrent();
  $scope.showHolidaysLoader = false;
  $scope.showNoHolidaysCircle = false;
  $scope.holidays = [];
  $scope.format = $translate.use() === 'en' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';

  // Filters
  $scope.filters = {
    filterType: 'all',
    areas: [],
    selected: {
      id: null,
      label: null
    }
  };
  $scope.queueSelect = [];
  $scope.queuesList = [];

  $scope.multiselectTranslations = {
    checkAll: $translate.instant('all'),
    uncheckAll: $translate.instant('multiselect_ninguno'),
    dynamicButtonTextSuffix: $translate.instant('multiselect_seleccionados'),
    buttonDefaultText: $translate.instant('select_one_or_more_filters'),
    searchPlaceholder: $translate.instant('search_lines_services'),
    selectGroup: $translate.instant('multiselect_seleccionar'),
  };

  $scope.areasSettings = {
    template: '<translate>{{option.label}}</translate>',
    externalIdProp: '',
    displayProp: 'label',
    idProp: '_id',
    searchField: 'label',
    enableSearch: true,
    showCheckAll: false,
    showUncheckAll: true,
    keyboardControls: true,
    selectedToTop: false,
    scrollable: true,
    selectByGroups: ['line', 'area'],
    groupByTextProvider: groupValue => {
      switch (groupValue) {
        case 'line':
          return $translate.instant('lines');
        case 'area':
          return $translate.instant('services');
        default:
          return $translate.instant('filters');
      }
    },
    groupBy: 'type',
  };

  const init = async () => {
    const areasPromise = AreaService.GetAllAsPromise();
    const placePromise = PlaceService.GetCurrentAsPromise();
    const holidayPromise = HolidayService.GetAll();
    const linesPromise = LineService.GetAllAsPromise();
    $scope.originalHolidays = await HolidayService.GetAll();
    await Promise.all([areasPromise, placePromise, holidayPromise, linesPromise])
      .then(async data => {
        $timeout(() => {
          $scope.holidays = data[2];
          $scope.areasList = sortBy(toArray(filter(data[0], area => area.appointmentsConfiguration.enabled)), ['label']);
          $scope.allLineList = sortBy(toArray(filter(data[3], line => line.open && line.realType === 'line')), ['label']);
          $scope.place = data[1];
          $scope.placeUTCOffset = moment.tz(data[1].timezone).format('Z').toString();
          const queuesAll = [...$scope.areasList, ...$scope.allLineList];
          setQueuesOptions(queuesAll);
          $scope.showNoHolidaysCircle = !data[2].length;
        });
      })
      .catch(ErrorService.handler);
  };


  const setQueuesOptions = queues => {
    $scope.queuesList = queues.map(queue => extend({ filterType: queue.type, group: queue.type }, queue));
  };

  $scope.applyFilters = () => {

    if (!$scope.queueSelect.length) {
      $scope.holidays = cloneDeep($scope.originalHolidays);
      return;
    }

    const onlyLinesAreas = $scope.queueSelect.filter((item) => item.filterType === 'area' || item.filterType === 'line');
    const onlyLines = $scope.queueSelect.filter((item) => item.filterType === 'line');
    const onlyAreas = $scope.queueSelect.filter((item) => item.filterType === 'area');
    let areaFilter = [];
    let lineFilter = [];

    let linesAreasIds = [];
    if (onlyLinesAreas.length) {
      linesAreasIds = onlyLinesAreas.map(item => item._id);
    }

    map($scope.originalHolidays, () => {

      if (onlyLines.length === $scope.allLineList.length) {
        lineFilter = filter($scope.originalHolidays, holiday => holiday.queueType === 'line' && (holiday.applyToAll === true || filterLinesAndAreas(holiday, linesAreasIds)));
      } else {
        lineFilter = filter($scope.originalHolidays, holiday => (holiday.queueType === 'line' && filterLinesAndAreas(holiday, linesAreasIds)));
      }

      if (onlyAreas.length === $scope.areasList.length) {
        areaFilter = filter($scope.originalHolidays, holiday => holiday.queueType === 'area' && (holiday.applyToAll === true || filterLinesAndAreas(holiday, linesAreasIds)));
      } else {
        areaFilter = filter($scope.originalHolidays, holiday => (holiday.queueType === 'area' && filterLinesAndAreas(holiday, linesAreasIds)));
      }

      $scope.holidays = concat(lineFilter, values(areaFilter));
    });
  }

  const filterLinesAndAreas = (holiday, linesAreasIds) => {
    const queueIds = holiday.queueIds.map(queue => queue._id);
    const intersectionIds = intersection(queueIds, linesAreasIds)
    if (intersectionIds.length) {
      return true;
    }
  }

  $scope.seeHolidayInfo = holiday => {
    $uibModal.open({
      templateUrl: '../../../templates/components/modals/holiday-info.html',
      size: 'md',
      controller: 'HolidayInfoController',
      resolve: {
        holiday: () => holiday,
      }
    });
  };

  $scope.deleteHoliday = holiday => {
    let description = holiday.description || '';
    dialog.confirm($translate.instant('holiday_{description}_remove_sure').replace('{description}', description))
      .then(() => {
        HolidayService.Remove(holiday._id)
          .then(() => {
            description = `<span class="bold">${description || ''}</span>`;
            NotificationService.Success($translate.instant('holiday_{description}_remove_succ').replace('{description}', description));
          })
          .catch(ErrorService.handler);
      });
  };

  $scope.editHoliday = holiday => {
    $uibModal.open({
      templateUrl: '../../../templates/components/modals/holiday.html',
      size: 'md',
      controller: 'HolidayController',
      resolve: {
        holiday: () => holiday
      }
    }).result.then(async () => {
      $scope.originalHolidays = await HolidayService.GetAll();
    })
  };

  init();
};

module.exports = module.controller('ScheduleHolidaysController', ScheduleHolidaysController);
